import background from "@assets/images/careers/background.png";
import { trans } from "@mongez/localization";
import {
  BellIcon,
  Briefcase,
  ClockIcon,
  ExternalLink,
  SquareCheckBig,
} from "lucide-react";

const CAREERS_PORTAL_URL =
  "https://elzx.fa.em2.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX_2001";

const APPLY_FEATURES = [
  {
    title: "careersPage.applyInUnderMinutes",
    icon: <ClockIcon className="h-6 w-6 text-bright-orange" />,
  },
  {
    title: "careersPage.getAlertByNewRoles",
    icon: <BellIcon className="h-6 w-6 text-bright-orange" />,
  },
  {
    title: "careersPage.trackApplicationStatus",
    icon: <SquareCheckBig className="h-6 w-6 text-bright-orange" />,
  },
];

export function CareersPageContent() {
  return (
    <section className="container py-20">
      <div className="flex flex-col gap-8">
        <div
          className="relative overflow-hidden rounded-3xl bg-cover bg-center"
          style={{ backgroundImage: `url(${background})` }}
        >
          <div className="relative z-10 flex flex-col items-center gap-4 px-6 py-12 text-center sm:gap-5 sm:px-10 sm:py-16 lg:py-20">
            <div className="flex size-14 items-center justify-center rounded-full bg-white/10 sm:size-16">
              <Briefcase className="h-6 w-6 text-bright-orange sm:h-7 sm:w-7" />
            </div>

            <span className="text-xs font-bold uppercase tracking-widest text-bright-orange sm:text-sm">
              {trans("careersPage.nextChapterEyebrow")}
            </span>

            <h2 className="max-w-2xl text-2xl font-bold text-white sm:text-3xl lg:text-4xl">
              {trans("careersPage.readyToShapeFuture")}
            </h2>

            <p className="max-w-xl text-sm text-white/70 sm:max-w-2xl sm:text-base">
              {trans("careersPage.exploreCareersDescription")}
            </p>

            <a
              target="_blank"
              rel="noopener noreferrer"
              href={CAREERS_PORTAL_URL}
              className="mt-2 inline-flex items-center gap-2 rounded-full bg-bright-orange px-6 py-3 text-sm font-semibold text-white transition-opacity hover:opacity-90 sm:px-8 sm:py-4 sm:text-base"
            >
              {trans("careersPage.exploreAndApply")}
              <ExternalLink className="h-4 w-4 sm:h-5 sm:w-5" />
            </a>

            <span className="text-xs text-white/50 sm:text-sm">
              {trans("careersPage.redirectNotice")}
            </span>
          </div>
        </div>

        <div className="mx-auto flex flex-wrap items-center gap-6 max-sm:max-w-60 sm:flex-row sm:justify-center">
          {APPLY_FEATURES.map((feature) => (
            <div key={feature.title} className="flex items-center gap-4">
              {feature.icon}
              <span className="text-center text-sm font-medium">
                {trans(feature.title)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
